__turbopack_context__.v({
  "background": "qzpR0W_background",
  "backgroundPhoto": "qzpR0W_backgroundPhoto",
  "button": "qzpR0W_button",
  "buttonReady": "qzpR0W_buttonReady",
  "buttonReadyIcon": "qzpR0W_buttonReadyIcon",
  "container": "qzpR0W_container",
  "description": "qzpR0W_description",
  "form": "qzpR0W_form",
  "header": "qzpR0W_header",
  "iconPhone": "qzpR0W_iconPhone",
  "input": "qzpR0W_input",
  "isCertificates": "qzpR0W_isCertificates",
  "isOnlineSearch": "qzpR0W_isOnlineSearch",
  "isRegistryPage": "qzpR0W_isRegistryPage",
  "isSimple": "qzpR0W_isSimple",
  "photo": "qzpR0W_photo",
  "title": "qzpR0W_title",
});
